module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"OpeningHours":{"statusClosed":"Nyní máme zavřeno","statusOpen":"Nyní máme otevřeno","closed":"zavřeno"}}}')
  delete Component.options._Ctor
}
